/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-14 10:11:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-21 17:12:41
 */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Row,
  Select,
} from 'antd'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import { DateTimeFormat, DateTimeFormatSimple } from '../../../models/datetime'
import {
  getPSCRecordDetailAsync,
  getPSCRecordSubmitAsync,
} from './PSCRecordListSlice'
import moment from 'moment'
import { getUserList } from '../../user/userSlice'

const { Option } = Select

export const AddOrEditFormLocationModal = (props: {
  editTenantId?: any
  isEdit?: any
  id?: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [detail, setDetail] = useState<any>()

  const [userList, setUserList] = useState<any>()

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 15 },
  }

  useEffect(() => {
    if (props.isModalVisible) {
      dispatch(getUserList({ current: 1, size: 1000, state: 1 }))
        .then(unwrapResult)
        .then((res: any) => {
          setUserList(res?.items)
        })
    }
  }, [props.isModalVisible])

  const getDetail = () => {
    dispatch(
      getPSCRecordDetailAsync({
        id: props?.id,
        tenantId: props?.editTenantId,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        setDetail(v)
        form.setFieldsValue({
          ...v,
          handlerId:
            v?.handlerId && v?.handlerId != -1
              ? v?.handlerId?.toString()
              : undefined,
          handleDate: v?.handleDate ? moment(v?.handleDate) : undefined,
        })
      })
  }

  useEffect(() => {
    if (props.isModalVisible) {
      if (props?.id) {
        getDetail()
      }
    } else {
      form.resetFields()
      setUserList([])
      setDetail({})
    }
  }, [props.isModalVisible, props?.id])

  return (
    <>
      <Modal
        width={1000}
        title={
          props?.isEdit == '0'
            ? '查看详情'
            : props?.id
            ? '编辑数据'
            : '添加数据'
        }
        visible={props.isModalVisible}
        footer={null}
        maskClosable={false}
        destroyOnClose={false}
        onCancel={() => {
          props.onCancel()
          form.resetFields()
        }}
        onOk={() => {
          props?.onOk()
        }}
      >
        <Form
          autoComplete='off'
          form={form}
          onFinish={(vs) => {
            setConfirmLoading(true)

            const handleDate = vs?.handleDate
              ? moment(vs?.handleDate)?.format(DateTimeFormat)
              : undefined

            const handlerName = userList?.find(
              (v: any) => v?.id == vs?.handlerId
            )?.name

            const params = props?.id
              ? {
                  ...vs,
                  id: detail?.id,
                  handlerName: handlerName,
                  handleDate: handleDate,
                }
              : {
                  ...vs,
                  handlerName: handlerName,
                  handleDate: handleDate,
                }
            dispatch(getPSCRecordSubmitAsync({ ...params }))
              .then(unwrapResult)
              .then((v: any) => {
                notification.success({
                  message: '操作成功',
                })
              })
              .finally(() => {
                props?.onOk()
                setConfirmLoading(false)
              })
          }}
        >
          <Row>
            <Col span={12}>
              <Form.Item {...layout} label='顾客姓名' name='customerName'>
                <Input placeholder='顾客姓名' />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                {...layout}
                label='联系电话'
                name='contactPhone'
                rules={[
                  {
                    pattern: /^(?=[0-9-]{5,20})[0-9]*-?[0-9]*-?[0-9]*$/,
                    message: '请输入正确的联系电话',
                  },
                ]}
              >
                <Input placeholder='联系电话' maxLength={13} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item label='地址' name='address' {...layout}>
                <Input placeholder='地址' />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label='咨询、服务与投诉内容'
                name='content'
                {...layout}
              >
                <Input placeholder='咨询、服务与投诉内容' />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item {...layout} label='处理意见' name='handleSuggestion'>
                <Input placeholder='处理意见' />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label='处理结果' name='handleResult'>
                <Input placeholder='处理结果' />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item
                {...layout}
                label='处理人'
                name='handlerId'
                rules={[
                  {
                    required: true,
                    message: '处理人不能为空',
                  },
                ]}
              >
                <Select placeholder='处理人' allowClear>
                  {userList?.map((v: any, i: any) => {
                    return (
                      <Option value={v?.id} key={i}>
                        {v?.name}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label='处理日期' name='handleDate'>
                <DatePicker
                  style={{ width: '100%' }}
                  placeholder='报损日期'
                  format={DateTimeFormatSimple}
                  onChange={() => {
                    return
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          {props?.isEdit == '0' ? (
            <></>
          ) : (
            <Row
              style={{
                marginTop: '20px',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Button
                loading={confirmLoading}
                type='primary'
                onClick={() => {
                  form.submit()
                }}
                style={{ marginRight: '10px' }}
              >
                确定
              </Button>
              <Button
                type='primary'
                ghost
                style={{ marginRight: '10px' }}
                onClick={() => {
                  props?.onCancel()
                }}
              >
                取消
              </Button>
            </Row>
          )}
        </Form>
      </Modal>
    </>
  )
}
